import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router";
import {
  FORM_TEMPLATE_INITIAL_ASSESMENT_SLUG,
  FORM_TEMPLATE_INITIAL_ASSESMENT_UUID,
  PARENT_FORM_CATEGORY_SLUG,
  USER_ROLE,
} from "Constants/constant";
import { apiGetRequest } from "helpers/Requests";
import { roleAccess } from "helpers/RolesPermission";
import {
  participantQuickSnapshotCall,
  participantSupportPlanCall,
} from "store/actions/participant.actions";
import {
  getParticipantQuickSnapshot,
  getParticipantSupportPlan,
  getQuickSnapshotLoading,
  getSupportPlanLoading,
} from "store/selector/participant.selector";
import QuickSnapshots from "components/common/QuickSnapshots/QuickSnapshots";
import SupportPlan from "components/common/SupportPlan/SupportPlan";
import RiskRatingTab from "../RiskRating/RiskRatingTab";
import LikesDislikes from "components/common/QuickSnapshots/LikesDislikes";
import { BLK_PORTAL_PREMISSION_KEYS_CHILDREN } from "store/constants";


const SupportPlanPage = (props) => {
  const {
    participantsInfo,
    setToggleState,
    getParticipantSupportPlan,
    isLoading,
    selectedSupportPlan,
    quickSnapShotLoading,
  } = props;

  const { uuid } = useParams();
  const [supportPlanData, setSupportPlanData] = useState(null);
  const navigate = useNavigate();
  const [request, setRequest] = React.useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  const initialAssessmentEditEnabled =
    !roleAccess([USER_ROLE.Sp_Standard_User]) ||
    roleAccess(
      [],
      "participant",
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.EDIT_ASSESSMENT_FORM
    );

  const initialAssessmentAddEnabled =
    !roleAccess([USER_ROLE.Sp_Standard_User]) ||
    roleAccess(
      [],
      "participant",
      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.SUBMITTED.FORM.ADD
    );

  const getEmployeeSupportPlan = async () => {
    setRequest({ ...request, isRequested: true });
    try {
      let response = await apiGetRequest(
        `hrm/participant/support-plan?pt_id=${participantsInfo.id}`
      );
      if (response.status !== 200) {
        setRequest({ ...request, isRequested: false, isFailed: true });
      } else if (response.status === 200) {
        setSupportPlanData(response.data.data);
      }
      setRequest({ ...request, isRequested: false, isSuccess: true });
    } catch (err) {
      setRequest({ ...request, isRequested: false, isSuccess: true });
    }
  };

  useEffect(() => {
    if (participantsInfo && uuid) {
      if (
        !selectedSupportPlan &&
        roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
      ) {
        getParticipantSupportPlan({ participantId: participantsInfo.id });
      }
    }
  }, []);

  useEffect(() => {
    if (roleAccess([USER_ROLE.Sp_Standard_User])) {
      getEmployeeSupportPlan();
    } else {
      setSupportPlanData(selectedSupportPlan);
    }
  }, [selectedSupportPlan]);

  const viewInitialAssesmentForm = (form_uuid) => {
    const basePath = roleAccess([USER_ROLE.Sp_Standard_User])
      ? "participant-profile"
      : "sp-profile";
    navigate(
      `/${basePath}/${PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG}/${form_uuid}/update`,
      {
        state: {
          participantId: participantsInfo ? participantsInfo.id : "1",
          particpantUuid: participantsInfo ? participantsInfo.uuid : "1",
          redirectTo: "overview",
        },
      }
    );
  };

  const addInitialAssesmentForm = () => {
    const item = {
      uuid: FORM_TEMPLATE_INITIAL_ASSESMENT_UUID,
      slug: FORM_TEMPLATE_INITIAL_ASSESMENT_SLUG,
    };
    navigate(
      `/view-template/${participantsInfo ? participantsInfo.uuid : "1"}/${
        PARENT_FORM_CATEGORY_SLUG.PARTICIPANT_ASSESSMENT.SLUG
      }/${item.slug}`,
      {
        state: {
          redirectTo: "overview",
        },
      }
    );
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Top Row: Quick Snapshot and Goals/Likes/Dislikes */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 sm:gap-6">
        {/* Quick Snapshot - Takes 2 columns on XL */}
        <div className="xl:col-span-2">
          <QuickSnapshots
            isLoading={quickSnapShotLoading}
            setToggleState={setToggleState}
            settingsData={participantsInfo}
            participantsInfo={participantsInfo}
            cssClass='text-white'
          />
        </div>
        
        {/* Goals, Likes & Dislikes - Takes 1 column on XL */}
        <div className="xl:col-span-1">
          <LikesDislikes
            viewInitialAssesmentForm={viewInitialAssesmentForm}
            addInitialAssesmentForm={addInitialAssesmentForm}
            initialAssessmentEditEnabled={initialAssessmentEditEnabled}
            initialAssessmentAddEnabled={initialAssessmentAddEnabled}
            isLoading={
              roleAccess([USER_ROLE.Sp_Standard_User])
                ? request.isRequested
                : isLoading
            }
            supportPlanData={supportPlanData}
            participantsInfo={participantsInfo}
          />
        </div>
      </div>
       
      {/* Support Plan - Full Width */}
      <div>
        <SupportPlan
          viewInitialAssesmentForm={viewInitialAssesmentForm}
          addInitialAssesmentForm={addInitialAssesmentForm}
          initialAssessmentEditEnabled={initialAssessmentEditEnabled}
          initialAssessmentAddEnabled={initialAssessmentAddEnabled}
          setToggleState={setToggleState}
          participantsInfo={participantsInfo}
          isLoading={
            roleAccess([USER_ROLE.Sp_Standard_User])
              ? request.isRequested
              : isLoading
          }
          supportPlanData={supportPlanData}
        />
      </div>
        
      {/* Risk Rating Tab - Full Width */}
      {participantsInfo && participantsInfo.uuid && (
        <div className="print:hidden">
          <RiskRatingTab
            participantsUid={participantsInfo.uuid}
            isReadOnly={true}
          />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  getParticipantSupportPlan: participantSupportPlanCall,
  getParticipantQuickSnapshot: participantQuickSnapshotCall,
};

const mapStateToProps = (state) => {
  const isLoading = getSupportPlanLoading(state);
  const selectedSupportPlan = getParticipantSupportPlan(state);
  const quickSnapShot = getParticipantQuickSnapshot(state);
  const quickSnapShotLoading = getQuickSnapshotLoading(state);
  return {
    isLoading,
    selectedSupportPlan,
    quickSnapShot,
    quickSnapShotLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupportPlanPage);
